export default __webpack_public_path__ + "static/media/tools.ec3d74ea.png";